// Onboarding flags — tiny localStorage wrapper. We use a single "shown" key
// so once ANY soft-signup prompt has been shown and dismissed (or converted),
// no further soft prompts fire on this device. Keeps the experience gentle.

const SHOWN_KEY = 'proxera.onboarding.softprompt.v1';

export function softPromptShown() {
  try { return localStorage.getItem(SHOWN_KEY) === '1'; } catch { return false; }
}

export function markSoftPromptShown() {
  try { localStorage.setItem(SHOWN_KEY, '1'); } catch {}
}
